import React from 'react';
import { Box, Typography, Alert } from 'components/mui';
import LoadingBackdrop from 'components/LoadingBackdrop';
import { SREDFilters, SREDSummaryCards, SREDPivotTable, SREDExportButton } from 'containers/pages/sredReport/components';
import { useSREDReport } from 'containers/pages/sredReport/hooks';

function SREDReport() {
  const { state, handler } = useSREDReport();

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: { xs: 2, sm: 3 },
      }}
    >
      <Typography variant="h5">SRED Hours Report</Typography>

      <SREDFilters
        params={state.params}
        onParamsChange={handler.onParamsChange}
        availableConsultants={state.availableConsultants}
        availableProjects={state.availableProjects}
      />

      {state.hasFetched && state.reportData && (
        <>
          <SREDSummaryCards summary={state.reportData.summary} />
          <SREDExportButton params={state.params} />
        </>
      )}

      {state.canFetch && (
        <SREDPivotTable
          rows={state.reportData?.rows || []}
          isLoading={state.isLoading}
          hasFetched={state.hasFetched}
        />
      )}

      <Typography variant="caption" color="text.secondary">
        Cases must have a keyword matching <strong>SRED [year] PRJ-[number]</strong> (e.g. "SRED 2023 PRJ-1") to appear in this report.
      </Typography>

      <LoadingBackdrop open={state.isLoading} />
    </Box>
  );
}

export default SREDReport;
